// extracted by mini-css-extract-plugin
module.exports = {"noReferrals":"no-referrals_noReferrals__W_u8A","image":"no-referrals_image__Y8duG","bodyText":"no-referrals_bodyText__CGJZf"};